// extracted by mini-css-extract-plugin
export var btnOpener = "light-box-image-module--btn-opener--87883";
export var captionContainer = "light-box-image-module--caption-container--d5664";
export var imagesContainer = "light-box-image-module--images-container--7a1e0";